import React from 'react';
import PropTypes from 'prop-types';
import styledComponent from '../../utils/styledComponent';
import theme from '../../theme';

const TONES = Object.keys(theme.statusPillTones);

// Generate one CSS rule per tone from the theme map, so the atom stays in
// sync with `theme.statusPillTones` automatically — adding a new tone token
// only requires updating theme.js.
const toneStyles = TONES.reduce((acc, tone) => {
  acc[`&.tone-${tone}`] = {
    color: theme.statusPillTones[tone].fg,
    background: theme.statusPillTones[tone].bg,
  };
  return acc;
}, {});

const StyledSpan = styledComponent('span', {
  display: 'inline-flex',
  alignItems: 'center',
  gap: theme.spacing.gapSm,
  padding: theme.spacing.smallBadgePadding,
  borderRadius: theme.radii.pill,
  ...theme.typography.badge,
  whiteSpace: 'nowrap',
  lineHeight: theme.lineHeights.tight,

  '& .ssp-icon': {
    display: 'inline-flex',
  },

  ...toneStyles,
});

const LockIcon = () => (
  <svg
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    aria-hidden="true"
    focusable="false"
    className="ssp-icon"
  >
    <rect
      x="1.75"
      y="4.25"
      width="6.5"
      height="4.5"
      rx="0.8"
      fill="currentColor"
    />
    <path
      d="M3 4.25V3a2 2 0 0 1 4 0v1.25"
      stroke="currentColor"
      strokeWidth="1"
      fill="none"
      strokeLinecap="round"
    />
  </svg>
);

function StopStatusPill({ tone, label, locked, tooltip }) {
  return (
    <StyledSpan className={`tone-${tone}`} title={tooltip || undefined}>
      {locked && <LockIcon />}
      <span className="ssp-label">{label}</span>
    </StyledSpan>
  );
}

StopStatusPill.propTypes = {
  tone: PropTypes.oneOf(TONES),
  label: PropTypes.string.isRequired,
  locked: PropTypes.bool,
  tooltip: PropTypes.string,
};

StopStatusPill.defaultProps = {
  tone: 'neutral',
  locked: false,
  tooltip: undefined,
};

export default StopStatusPill;
